import '../social_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.InstagramUnsupportedMessageView extends
Monitoring.Views.SocialContents.SocialContentView

  togglePhoto: (event) =>
    @$el.toggleClass('collapsed expanded', 0)

  render: ->
    super()
    if @model.get('content').message.isKeepconUnsupported
      iconView = @_unsupportedByKeepconIcon()
    else
      iconView = @_unsupportedByInstagramIcon()
    @$el.addClass("inbox #{@model.type()}")
    @$el.addClass('clipping-news') if @model.isClippingNews?()
    @$el.find('.sc-text-shortener').prepend(iconView.render().el)
    @$el.find('.sc-text-shortener').addClass('unsupported-instagram-message-container')
    @

  _unsupportedByKeepconIcon: ->
    new Common.SvgIconView(
      svgPath: 'icons/unsupported-by-keepcon.svg'
      svgId: 'unsupported-by-keepcon'
      iconClass: 'unsupported-message-icon'
    )

  _unsupportedByInstagramIcon: ->
    new Common.SvgIconView(
      svgPath: 'icons/unsupported-by-instagram.svg'
      svgId: 'unsupported-by-instagram'
      iconClass: 'unsupported-message-icon'
    )
